import { render, staticRenderFns } from "./CourseOverviewListing.vue?vue&type=template&id=1170f46f&"
import script from "./CourseOverviewListing.vue?vue&type=script&lang=js&"
export * from "./CourseOverviewListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports